import type { Artifact } from '@ideoz/core';
import { ArtifactRow } from './ArtifactRow';

interface ArtifactsListProps {
  artifacts: Artifact[];
  deletingId: string | null;
  onOpen: (artifact: Artifact) => void;
  onDelete: (id: string) => void;
}

/** Dumb: the artifact list. */
export function ArtifactsList({
  artifacts,
  deletingId,
  onOpen,
  onDelete,
}: ArtifactsListProps): JSX.Element {
  return (
    <ul className="divide-y divide-gray-100 dark:divide-gray-700">
      {artifacts.map((art) => (
        <ArtifactRow
          key={art.id}
          artifact={art}
          isDeleting={deletingId === art.id}
          onOpen={() => onOpen(art)}
          onDelete={onDelete}
        />
      ))}
    </ul>
  );
}
